import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Functional route guard that protects routes requiring authentication.
 * Redirects unauthenticated users to /login, preserving query parameters
 * (important for tenant resolution via ?tenantid=xxx).
 *
 * When authenticated, checks if the user must change their password
 * (temp password flow) and redirects to /force-change-password if so.
 *
 * Validates: Requirements 2.4, 5.2, 5.6
 */
export const authGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    // Preserve query params (e.g., tenantid) when redirecting to login
    const queryParams = route.queryParams;
    return router.createUrlTree(['/login'], { queryParams });
  }

  // Block all navigation while must-change-password is active,
  // except navigation to the force-change-password page itself (avoid redirect loop)
  if (authService.mustChangePassword()) {
    const targetPath = route.routeConfig?.path;
    if (targetPath !== 'force-change-password') {
      return router.createUrlTree(['/force-change-password']);
    }
  }

  return true;
};
